import { Config } from "../../configurations/config";
export const OffsiteHours_API = {
  //------------------------ Offsite Work Hours Listing Screen API -----------------------//

  GetOffsiteHoursList: `${Config.server_url}${Config.api_prefix}/OffsiteHours?`,
  GetOffsiteHoursbyPagination: `${Config.server_url}${Config.api_prefix}/OffsiteHours?`,

  //------------------------ Create/View Offsite Work Hours Form APIS -----------------------//

  GetWorkType: `${Config.server_url}${Config.api_prefix}/OffsiteHours/GetWorkTypes`,
  PostOffsiteRequest: `${Config.server_url}${Config.api_prefix}/OffsiteHours`,
  GetOffsiteHoursById: `${Config.server_url}${Config.api_prefix}/OffsiteHours`,
  DeleteOffsiteWorkHours: `${Config.server_url}${Config.api_prefix}/OffsiteHours`,
  UpdateOffsiteWorkHours: `${Config.server_url}${Config.api_prefix}/OffsiteHours`,
};
